module.exports = __webpack_public_path__ + "0de8ca758873b417860906402a8408d5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/modern-mansion-empty.png
// module id = 331
// module chunks = 0